<template>
  <div class="link-button__container">
    <el-button
        v-acl.show="{permission: 'overrideAuth', on: 'Customer'}"
        type="text"
        :disabled="disabled"
        @click="$emit('click', true)">
      <slot></slot>
    </el-button>
  </div>
</template>

<script>
export default {
  name: "LinkButton",
  emits: ["click"],
  props: {
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
};
</script>

<style scoped>
.link-button__container {
  display: flex;
  justify-content: center;
  width: 100%;
}

.el-button--text,
.el-button--text:hover {
  font-family: "Equip";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: #10628a;
  text-decoration-line: underline;
  padding: 0;
}
</style>
